import { render, staticRenderFns } from "./article.vue?vue&type=template&id=2ab497f0&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&lang=css&"
import style1 from "./article.vue?vue&type=style&index=1&id=2ab497f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab497f0",
  null
  
)

export default component.exports